// `Symbol.species` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.species
require('../internals/define-well-known-symbol')('species');



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/modules/es.symbol.species.js
// module id = 291
// module chunks = 1